import { render, staticRenderFns } from "./LogicalAxiomeCardinality.vue?vue&type=template&id=45c6da38"
import script from "./LogicalAxiomeCardinality.vue?vue&type=script&lang=js"
export * from "./LogicalAxiomeCardinality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports